<script setup>
import { computed, ref } from 'vue'
import { useCalendarStore } from '@/views/apps/calendar/useCalendarStore'
import { useI18n } from 'vue-i18n'
import { sanitizeHtml } from "@/utils/strings"

const { t } = useI18n()
const calendarStore = useCalendarStore()

const dialog = computed(() => {
  return calendarStore.terms && typeof calendarStore.terms === 'object'
})

const isLoading = ref(false)

const handleConfirm = async () => {
  if (!calendarStore.terms?.id) return

  isLoading.value = true
  try {
    const response = await $backend('/terms/accept', {
      method: 'POST',
      body: {
        id: calendarStore.terms.id,
      },
    })

    if (response.success) {
      calendarStore.terms = false
    }
  } catch (error) {
    console.error('Error accepting terms:', error)
  } finally {
    isLoading.value = false
  }
}
</script>

<template>
  <VDialog
    v-model="dialog"
    class="terms-dialog"
    persistent
    max-width="1024"
  >
    <VCard class="pa-2 d-flex flex-column" style="max-block-size: 80vh;">
<!--       <VCardTitle class="text-left flex-shrink-0">-->
<!--        {{ t('terms_title') }}-->
<!--      </VCardTitle>-->
      <VCardText
        v-if="calendarStore.terms?.content"
        v-html="sanitizeHtml(calendarStore.terms.content)"
        class="flex-grow-1 overflow-y-auto"
      />
      <VCardActions class="justify-end mt-2 flex-shrink-0">
        <VBtn
          color="green"
          variant="flat"
          :loading="isLoading"
          @click="handleConfirm"
        >
          {{ t('confirm_agreement') }}
        </VBtn>
      </VCardActions>
    </VCard>
  </VDialog>
</template>

<style>
  .terms-dialog {
    h2 {
      margin-block-end: 1rem;
    }

    ol {
      margin-block-end: 1rem;
    }

    li {
      margin-block-end: 0.25rem;
    }
  }
</style>
